import { render, staticRenderFns } from "./listagemUsuarios.vue?vue&type=template&id=382b5a0c&scoped=true"
import script from "./listagemUsuarios.vue?vue&type=script&lang=js"
export * from "./listagemUsuarios.vue?vue&type=script&lang=js"
import style0 from "./listagemUsuarios.vue?vue&type=style&index=0&id=382b5a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382b5a0c",
  null
  
)

export default component.exports